// extracted by mini-css-extract-plugin
var _1 = "close-btn___3gXxX";
var _2 = "label-link___d0n_J";
var _3 = "label-tag___jXTBx";
export { _1 as "close-btn", _2 as "label-link", _3 as "label-tag" }
